import api from "@/lib/axios";

export enum LevelsKeys {
  GET_LICENSEE_PROGRESSION = "levels-get-licensee-progression",
  GET_STARTER_PROGRESS = "levels-get-starter-progress",
}

export interface LicenseeProgression {
  nicheDefined?: boolean;
  courseCompleted?: boolean;
  landingPageSubmitted?: boolean;
  demoPublished?: boolean;
  level?: string;
}

export interface UpdateLicenseeProgressionDto {
  hasSharedDemo?: boolean;
  hasCompletedPlaybook?: boolean;
  nicheDefined?: boolean;
}

export interface StarterLicenseeProgress {
  id: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  email: string;
  progress: {
    nicheDefined: boolean;
    courseCompleted: boolean;
    landingPageSubmitted: boolean;
    demoPublished: boolean;
  };
  timestamps: {
    nicheDefinedAt?: string | Date | null;
    courseCompletedAt?: string | Date | null;
    landingPageSubmittedAt?: string | Date | null;
    demoPublishedAt?: string | Date | null;
  };
}

export type StarterLicenseesProgressResponse = StarterLicenseeProgress[];

export const getLicenseeProgression = async (id: string) => {
  const response = await api.get(`/levels/${id}/progression`);
  return response.data as LicenseeProgression;
};

export const updateLicenseeProgression = async (
  id: string,
  progressionDto: UpdateLicenseeProgressionDto,
) => {
  const response = await api.patch(`/levels/${id}/progression`, progressionDto);
  return response.data as LicenseeProgression;
};

export const getStarterProgress =
  async (): Promise<StarterLicenseesProgressResponse> => {
    const response = await api.get<StarterLicenseesProgressResponse>(
      "/levels/starter/progress",
    );
    return response.data;
  };
